import { ListItem } from "@chakra-ui/react";

const Dots = () => (
  <ListItem px={{ base: 3, md: 4 }} py={{ base: 2, md: 3 }} fontSize="sm" fontWeight="medium">
    &#8230;
  </ListItem>
);

export default Dots;
